import LogoutIcon from "@mui/icons-material/Logout";
import { AppBar, Box, Button, Grid, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ChooseLanguage from "../../components/base/ChooseLanguage";
import { useAuth } from "../../context/auth";
import { USER_ROLES } from "../../helpers/constants";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import { LandingPageTile } from "../LandingPage/LandingPageTile";
import { BackGroundImage } from "../../media/background";
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import ApartmentIcon from '@mui/icons-material/Apartment';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PeopleIcon from '@mui/icons-material/People';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';


    
import { useQuery } from "@tanstack/react-query";
import useLandingPageService from "../../services/landingPageService";

export const SalesLandingPage = () => {
    const { logout, getMyHomeSelectedPage } = useAuth();
    const { t } = useTranslation();

    const handleLogout = () => {
        logout();
    };

    const { hasAccess } = useAccessControl([USER_ROLES.ADMIN, USER_ROLES.SALES_MANAGER]);

    const landingPageService = useLandingPageService();
    const proposalsCountQuery = useQuery({
        queryKey: ["proposalsCount"],
        queryFn: landingPageService.getProposalsCount,
        retry: 1,
    });

    if (!hasAccess) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                // minHeight: "100vh",

                marginTop: -1,
                backgroundImage: `url(${BackGroundImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "right",
                marginBottom: "-40px"
            }}
        >
            {/* AppBar with Logout Button and Language Selector */}
            <AppBar position="static" color="primary">
                <Toolbar sx={{ justifyContent: "flex-end" }}>
                    {/* <ChooseLanguage /> */}
                    <Button
                        color="inherit"
                        sx={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "rgba(255,255,255,0.15)",
                            "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.39)",
                            },
                            borderRadius: 2,
                            px: 3,
                        }}
                        onClick={() => (window.location.href = "/")}
                    >
                        {t("page.sales_landing_page.return")}
                    </Button>
                    <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>
                        {t("log_out")}
                    </Button>
                </Toolbar>
            </AppBar>
            {/* Main Content */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    flexGrow: 1,
                    // padding: 3,
                }}
            >
                <Typography
                    variant="h2"
                    component="h2"
                    align="center"
                    style={{  fontSize:"50px", marginTop: 10 }}
                >
                    {t("page.sales_landing_page.welcome")}
                </Typography>

                <Grid
                    container
                    justifyContent="flex-start"
                    spacing={1}
                    sx={{
                        // maxWidth: 2500,
                        margin: "0 auto",
                        marginLeft: 0,
                        paddingLeft:0,
                        marginTop:"-75px",
                        marginBottom: 0
                    }}
                >
                    <Grid item xs={2}>
                        <LandingPageTile
                            title={t("page.sales_landing_page.documents")}
                            pageUrl={"/sales-manager/documents/"}
                            icon={<DocumentScannerIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "110px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <LandingPageTile
                            title={t("page.sales_landing_page.proposals")}
                            query={proposalsCountQuery}
                            showActiveTotalCountFactor={true}
                            activeCountLabel={t("page.landing_page.active")}
                            pageUrl={"/sales-manager/proposals/"}
                            icon={<ConnectWithoutContactIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "110px", marginLeft: "-30px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.sales_landing_page.investment_configuration")}
                            pageUrl={"/sales-manager/investment-configuration/"}
                            icon={<DomainDisabledIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.sales_landing_page.products_table")}
                            pageUrl={"/sales-manager/products/"}
                            icon={<ApartmentIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.sales_landing_page.drafts")}
                            pageUrl={"/sales-manager/drafts/"}
                            icon={<EditNoteIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.sales_landing_page.sellers")}
                            pageUrl={"/sales-manager/sellers/"}
                            icon={<PeopleIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};
